import moment from 'moment/moment'

import { ConstructorArgs } from '../types/models'
import { BaseRecord } from './BaseRecord'
import { Conference } from './Conference'
import { FKType } from './SQLBuilder'
import { User } from './User'

export type ParticipantConstructorArgs = ConstructorArgs<() => Participant>

export class Participant extends BaseRecord {
    readonly recordType = 'participant'

    completedDate?: moment.Moment

    constructor(data?: Partial<ParticipantConstructorArgs>) {
        super(data)
        if (!data) {
            return
        }

        this.completedDate = this.propertyFromTimestampArg(data.completed_date)
    }

    clone(overrides?: Partial<ParticipantConstructorArgs>): Participant {
        return new Participant({ ...this.serializeForClone(), ...overrides })
    }

    get identity(): string {
        return this.id!
    }

    deserialize(data: any) {
        super.deserialize(data)
        if (data.person) this.person = BaseRecord.fromSerializer(data.person, User)
        if (data.conference)
            this.conference = BaseRecord.fromSerializer(data.conference, Conference)
        if (data.completedDate) this.completedDate = moment(data.completedDate)
    }

    static fk: FKType = {
        users: ['person'],
        conferences: ['conference'],
    }

    get conference(): Conference | undefined {
        return this.getForeignRecord('conference', Conference)
    }
    set conference(conference: Conference | undefined) {
        this.setForeignRecord('conference', conference)
    }
    get person(): User | undefined {
        return this.getForeignRecord('person', User)
    }
    set person(person: User | undefined) {
        this.setForeignRecord('person', person)
    }
}
